module.exports = __webpack_public_path__ + "img/confeti.9342a6a8.svg";